import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpService } from './http.service';
import { AppConfig } from '../app.config';
import { DIMBO_CONSTANT } from '../utils/constant';
import { BrandcareFormResponse } from '../model/brandcare-form-response';
import { shareReplay, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
/**
 * BrandCare form service with in-memory and in-flight caching.
 * Use getBrandcareForm() to fetch; clearCache() to reset.
 */
export class BrandcareFormService {
  domain: string;
  private cachedResponse: BrandcareFormResponse | null = null;
  private cachedObservable: Observable<BrandcareFormResponse> | null = null;

  constructor(
    private httpService: HttpService,
    private apiconfig: AppConfig
  ) {
    let apipath = '';
    // if (this.apiconfig.mpsaFlag === 'N') {
    //   apipath = location.protocol + '//' + this.apiconfig.apiUrl;
    // }
    apipath=this.apiconfig.apiUrl;
    this.domain = apipath + this.apiconfig.apiPath;
  }

  getBrandcareForm(): Observable<BrandcareFormResponse> {
    if (this.cachedResponse) {
      return of(this.cachedResponse);
    }
    if (this.cachedObservable) {
      return this.cachedObservable;
    }
    const finalUrl = this.domain + DIMBO_CONSTANT.BRANDCARE_FORM;
    this.cachedObservable = this.httpService.get(finalUrl).pipe(
      tap((resp: BrandcareFormResponse) => {
        this.cachedResponse = resp;
      }),
      shareReplay(1)
    );
    return this.cachedObservable;
  }

  clearCache() {
    this.cachedResponse = null;
    this.cachedObservable = null;
  }
}
